<template>
  <div class="collectionCard">
    <router-link :to="{path: link}">
      <div class="collectionCard__thumb">
        <img class="img-rounded" :src="img" :alt="title">
      </div>
      <h2 class="collectionCard__title " v-if="title">
        <span class="subhead">
          {{title}}
        </span>
      </h2>
      <p class="collectionCard__description clampMe small-font" v-if="description">{{description}}</p>
      <p class="collectionCard__price small-font" v-if="price">Price {{price | formatMoney}}/day</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'adx-collection-card',
  props: {
    img: { required: true },
    title: { required: true },
    price: { required: true },
    description: { required: true },
    link: { required: true }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>